/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accountdataexportbody3Inputs */

const en_accountdataexportbody3 = /** @type {(inputs: Accountdataexportbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get a copy of every record we hold about you (RGPD art. 15). Returns JSON with profile, cases, timeline, messages, files (with signed download links), and artifacts.`)
};

const pt_accountdataexportbody3 = /** @type {(inputs: Accountdataexportbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receba uma cópia de todos os registos que mantemos sobre si (RGPD art. 15.º). Devolve JSON com perfil, casos, cronologia, mensagens, ficheiros (com links de descarga assinados) e artefactos.`)
};

/**
* | output |
* | --- |
* | "Get a copy of every record we hold about you (RGPD art. 15). Returns JSON with profile, cases, timeline, messages, files (with signed download links), and ar..." |
*
* @param {Accountdataexportbody3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const accountdataexportbody3 = /** @type {((inputs?: Accountdataexportbody3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountdataexportbody3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_accountdataexportbody3(inputs)
	return pt_accountdataexportbody3(inputs)
});
export { accountdataexportbody3 as "accountDataExportBody" }